import React from 'react'
import { Header } from 'components/Header'
import { Button, Flex } from '@workwhile/ui'
import { QueryStatus } from 'components/QueryStatus'
import { useShiftsContextValue } from '../context/ShiftsProvider'
import { useNavigate } from 'react-router'
import * as ROUTES from 'constants/routes'

export const ShiftsHeader = () => {
  const { state, actions } = useShiftsContextValue()
  const navigate = useNavigate()

  const handleBulkCreateShifts = () => {
    navigate(ROUTES.BULK_CREATE_SHIFTS)
  }

  return (
    <Header
      title="Shifts"
      rightContent={
        <Flex alignItems="center" gap={2}>
          <QueryStatus
            dataUpdatedAt={state.dataUpdatedAt}
            isFetching={state.isFetching}
            refetch={actions.refetch}
            isError={state.isError}
            error={state.error}
          />
          <Button
            variant="primary"
            kind="medium"
            onClick={handleBulkCreateShifts}
          >
            Create shifts
          </Button>
        </Flex>
      }
    />
  )
}
